// PULL / COLLECT buttons below the lever, the log line and the offer-yourself confirm.
import { t } from '../../i18n/t';
import { controller } from '../../render';
import { setUI, useGame, useUI } from '../../state/store';
import { Btn, Frame, KText, useFmt } from '../common';

export function Actions() {
  const phase = useGame((g) => g.run?.phase);
  const spinsLeft = useGame((g) => g.run?.window.spinsLeft ?? 0);
  const night = useGame((g) => (g.run?.nightShift?.left ?? 0) > 0);
  const handOwned = useGame((g) => (g.meta.nodes.H_AUTOSPIN ?? 0) > 0);
  const auto = useGame((g) => g.meta.hand.autospin);
  const stage = useUI((u) => u.stage);
  if (!phase || stage !== 'play') return null;
  const canPull = (phase === 'ready' && (spinsLeft > 0 || night)) || phase === 'nudge';
  return (
    <div className="interactive col" style={{ position: 'absolute', left: 452, top: 268, width: 58, gap: 6 }}>
      <Btn kind="primary" disabled={!canPull || auto} onClick={() => controller.pull(false)} testId="pull">
        {t('ui.pull')}
      </Btn>
      {handOwned && (
        <div className="row" style={{ gap: 2 }}>
          <Btn kind={auto ? 'gold' : 'normal'} onClick={() => controller.toggleHand()} testId="hand" style={{ flex: 1, padding: '2px 2px 3px' }}>
            {auto ? t('ui.hand.on') : t('ui.hand.auto')}
          </Btn>
          <Btn kind="ghost" onClick={() => setUI({ panel: 'hand' })} style={{ padding: '2px 2px 3px' }}>
            ⚙
          </Btn>
        </div>
      )}
      {phase === 'nudge' && (
        <Btn onClick={() => controller.act({ t: 'COLLECT' })} testId="collect">
          {t('ui.collect')}
        </Btn>
      )}
    </div>
  );
}

export function LogLine() {
  const log = useUI((u) => u.log);
  const last = log[log.length - 1];
  const text = last ? t(last.key, last.params) : '';
  return <div className="logline">{last && <KText text={last.glitch ? text.toLowerCase() : text} />}</div>;
}

export function OfferConfirm() {
  const open = useUI((u) => u.confirmOffer);
  if (!open) return null;
  return (
    <div className="overlay">
      <Frame style={{ width: 240, textAlign: 'center' }}>
        <div className="col" style={{ gap: 8, padding: 6 }}>
          <div className="h" style={{ color: '#e83b3b' }}>
            {t('ui.offerSelf')}
          </div>
          <div>{t('ui.offer.confirm')}</div>
          <div className="row" style={{ justifyContent: 'center', gap: 10 }}>
            <Btn onClick={() => setUI({ confirmOffer: false })}>{t('ui.offer.no')}</Btn>
            <Btn
              kind="danger"
              onClick={() => {
                setUI({ confirmOffer: false });
                controller.act({ t: 'OFFER_SELF' });
              }}
              testId="offer-confirm"
            >
              {t('ui.offer.yes')}
            </Btn>
          </div>
        </div>
      </Frame>
    </div>
  );
}

/** Double or Devoured offer after a Big+ win (docs/04 §17.2). */
export function GambleOffer() {
  const gamble = useGame((g) => (g.run?.phase === 'gamble' ? g.run.gamble : null));
  const busy = useUI((u) => u.busy);
  const fmt = useFmt();
  if (!gamble || busy) return null;
  return (
    <div className="interactive col" style={{ position: 'absolute', left: 190, top: 150, width: 220, alignItems: 'center' }}>
      <Frame style={{ textAlign: 'center', width: 220 }}>
        <div className="col" style={{ gap: 6, alignItems: 'center', padding: 4 }}>
          <span className="h kw-bad">{t('ui.gamble.title')}</span>
          <span className="kw-value">{t('ui.gamble.stake', { coins: fmt(gamble.stake) })}</span>
          <div className="row" style={{ gap: 8 }}>
            <Btn kind="danger" onClick={() => controller.act({ t: 'GAMBLE_ACCEPT' })} testId="gamble-accept">
              {t('ui.gamble.accept')}
            </Btn>
            <Btn kind="primary" onClick={() => controller.act({ t: 'GAMBLE_DECLINE' })} testId="gamble-decline">
              {t('ui.gamble.decline')}
            </Btn>
          </div>
        </div>
      </Frame>
    </div>
  );
}
